export default __webpack_public_path__ + "static/media/Night-rainy.96679237.svg";